import { TextStyled } from '@procurify/ui'
import styled, { css } from 'styled-components'

const baseTextStyles = css<{ disabled?: boolean }>`
  /* Hover and focus styles... */
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover,
      &:focus-visible {
        color: ${({ theme }) => theme.colors.text.link};
      }
    `}

  /* Disabled styles... */
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.colors.text.disabled};
    `}
`

export const InteractiveFieldStyled = styled.div<{ disabled?: boolean }>`
  display: inline-block;

  ${({ disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
    `}

  ${TextStyled} {
    ${baseTextStyles}
  }
`
